import React, { useContext, useState } from 'react';
import AssessmentOptions from '@/components/pages/assessments/AssessmentOptions';
import AssessmentActions from '@/components/pages/assessments/AssessmentActions';
import AssessmentHelperNote from '@/components/pages/assessments/AssessmentHelperNote';
import AssessmentQuestion from '@/components/pages/assessments/AssessmentQuestion';
import { stepContext } from '@/components/pages/assessments/context/step.context';
import { displayContext } from '@/components/pages/assessments/context/display.context';
import { getQuestionMeta } from '@/components/pages/assessments/util.js';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';

const AssessmentStep = ({ answer, handleNext, question }) => {
  // Note that the `key` is important to distinguish between two consecutive AssessmentOptions that render the
  // same class of child component (e.g. 2 QuestionYesNo components in a row).
  const { getAnswerForQuestion, holdStep, metadata } = useContext(stepContext);
  const { css, cols } = useContext(displayContext);
  const stepClassName = css(`question-type-${question?.question?.value_type}`);
  const [stepCanProceed, setStepCanProceed] = useState(false);
  const defaultValue = typeof question?.default_value == 'undefined' ? undefined : question.default_value;
  const [selection, setSelection] = useState(getAnswerForQuestion(answer, question?.id, defaultValue));

  return (
    <Row className={`${css(`assessment-step ${stepClassName}`)}`}>
      <Col className={`${css(`assessment-step-question mobile-full-width-column ${cols.question.leftClass}`)}`} {...cols.question.left}>
        <Container fluid className={`${css('assessment-column-container')}`}>
          <AssessmentQuestion question={question} />
        </Container>
      </Col>
      <Col className={`${css(`assessment-step-body mobile-full-width-column ${cols.question.rightClass}`)}`} {...cols.question.right}>
        <Container fluid className={css('assessment-column-container')}>
          <AssessmentHelperNote note={question?.question?.helper_note} title={getQuestionMeta(question.id, metadata)?.helper_note_title} />
          <AssessmentOptions
            key={question.id}
            question={question}
            answer={selection}
            setStepCanProceed={setStepCanProceed}
            handleAnswer={setSelection}
            optionMapping={metadata?.custom_mapping?.[question.id]?.answers}
          />
        </Container>
      </Col>
      <Col className={css(`${cols.question.buttonClass}`)} {...cols.question.buttons}>
        <AssessmentActions enableNext={stepCanProceed && !holdStep} handleNext={handleNext} selection={selection} />
      </Col>
    </Row>
  );
};

export default AssessmentStep;
